import { render, staticRenderFns } from "./ResumenVentasKpis.vue?vue&type=template&id=0011b7a9"
import script from "./ResumenVentasKpis.vue?vue&type=script&setup=true&lang=js"
export * from "./ResumenVentasKpis.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports